module.exports = __webpack_public_path__ + "img/Convertible_mobile.4d639176.jpg";